export default {"src":"/_next/static/media/verified.88e3c121.svg","height":21,"width":23,"blurWidth":0,"blurHeight":0};